import React from 'react';
import SvgIcon from 'src/react_components/svg-icon';

type CommentHelper = {
  id: number,
  category: string,
  summary: string,
  deleting: boolean
}

type FeedbackCommentHelperSectionProps = {
  commentHelper: CommentHelper,
  deleteCommentHelper: (commentHelper: CommentHelper) => void
}

const FeedbackCommentHelperSection: React.FC<FeedbackCommentHelperSectionProps> = ({
  commentHelper, deleteCommentHelper
}) => {
  const deleteThisCommentHelper = () => deleteCommentHelper(commentHelper);
  const { summary, deleting } = commentHelper;
  const { editable } = window.Annotator;

  // or could render greyed-out
  if (deleting || !summary) {
    return null;
  }

  return (
    <div className="feedback-area-comment-helper">
      {
        editable ? (
          <button
            type="button"
            aria-label="Remove comment helper for feedback area"
            className="btn-plaintext pull-right delete-button"
            onClick={deleteThisCommentHelper}
          >
            <SvgIcon className="icon-lg" icon="highlight_remove" />
          </button>
        ) : ''
      }
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: summary }} />
    </div>
  );
};

export default FeedbackCommentHelperSection;
